// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const FAVORITE_GIF_LIMIT_REACHED_DESCRIPTOR = msg({
	message: "You're at the favorite GIF limit.",
	comment: 'Limit text shown when no more favorite GIFs can be added.',
});
